export const getOrderId = order => {
  return order.order_id !== undefined ? order.order_id : order.id
}